import { action, observable } from 'mobx'
import { createContext } from 'react'

import { BaseStore } from './BaseStore'

const DEFAULT_FILTERS = {
  dealerGroup: [],
  manufacturer: [],
  admin: [],
  assistantManager: [],
  manager: [],
  dealerManagementSystem: [],
  selfManaged: [],
}

const INITIAL_STATE = {
  loading: false,
  lastUpdated: null,
  error: null,
  filters: DEFAULT_FILTERS,
  selectedFilters: DEFAULT_FILTERS,
  sortedColumn: 'name',
  currentPage: 1,
  perPage: 20,
  type: 'wpc',
}

const TYPES = {
  data: observable,
  loading: observable,
  error: observable,
  lastUpdated: observable,
  filters: observable,
  selectedFilters: observable,
  sortedColumn: observable,
  currentPage: observable,
  perPage: observable,
  type: observable,
}

export class DashboardStore extends BaseStore {
  setFilters = action((filters) => {
    this.filters = filters
  })

  setSelectedFilters = action((filters) => {
    this.selectedFilters = filters
  })

  setSortedColumn = action((column) => {
    this.sortedColumn = column
  })

  setCurrentPage = action((page) => {
    this.currentPage = page
  })

  setPerPage = action((perPage) => {
    this.perPage = perPage
  })

  resetFilters = action(() => {
    this.selectedFilters = DEFAULT_FILTERS
  })

  setType = action((type) => {
    this.type = type
  })
}

export const dashboard = new DashboardStore(INITIAL_STATE, TYPES)
export const DashboardStoreContext = createContext(dashboard)
